// extracted by mini-css-extract-plugin
module.exports =  {"root":"RCgHPF5qhG9vvOdmIjry","tabContent":"DoNeGDuu7u9D1smP4uMV"};